// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608251004/js/" + chunkId + "." + {"44":"1cb86106","225":"a7d950db","481":"b6586cef","486":"24190bee","770":"dde7a5d4"}[chunkId] + ".0.7325636707656917.chunk.js";
};